// src/services/warehouseProductionService.js
import ApiService from './api'

const WarehouseProductionService = {
  // Get all warehouse productions
  getAllWarehouseProductions: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString()
      const url = queryString ? `/warehouse-productions?${queryString}` : '/warehouse-productions'
      const response = await ApiService.get(url)
      return response
    } catch (error) {
      console.error('Error fetching warehouse productions:', error)
      throw error
    }
  },

  // Create warehouse production
  createWarehouseProduction: async (productionData) => {
    try {
      const response = await ApiService.post('/warehouse-productions', productionData)
      return response
    } catch (error) {
      console.error('Error creating warehouse production:', error)
      throw error
    }
  }
}

export default WarehouseProductionService
